import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { ProductSelectorWrapperContainer } from "./product-selector-wrapper.container";

const DIRECTIVES = [ProductSelectorWrapperContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule, GlobalUiModule, RouterModule, StoreModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ProductSelectorWrapperModule {}
